




















































































































import {Auth} from 'aws-amplify';
import awsExports from '@/aws-exports.js';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import i18n from '@/i18n.ts';

@Component
export default class AnimalSubscribe extends Vue {
  public $refs!: {
    form: any,
  };

  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;
  private amount: string = '';
  private paymentMethod: number = 1;
  private firstName: string = '';
  private lastName: string = '';
  private paymentAmounts: any = [
    {
      text: '$5',
      value: '5',
    },
    {
      text: '$10',
      value: '10',
    },
    {
      text: '$20',
      value: '20',
    },
    {
      text: i18n.t('user.animals.customAmount'),
      value: '-1',
    },
  ];
  private selectedAmount: string = '5';

  private genders: any = [
    {
      text: i18n.t('user.animals.male'),
      value: 'male',
    },
    {
      text: i18n.t('user.animals.female'),
      value: 'female',
    },
  ];
  private gender: string = '';

  @Prop({type: Object, default: {}}) private animal!: any;
  @Getter('common/rules/all') private rules!: any;

  @Action('user/subscriptions/create') private createSubscription!: any;

  private async subscribe() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      if (this.selectedAmount !== '-1') {
        this.amount = this.selectedAmount;
      }
      // const val = Math.round(100 * parseFloat(this.amount));

      // const user = await Auth.currentUserInfo();
      const user = await Auth.currentAuthenticatedUser();

      await Auth.updateUserAttributes(user, {
        given_name: this.firstName,
        family_name: this.lastName,
        gender: this.gender,
      });

      let paymentEndpoint = '';
      if (awsExports && awsExports.aws_cloud_logic_custom instanceof Array) {
        const endpoints =
          awsExports.aws_cloud_logic_custom.filter((elem: any) => elem.name === 'robinhoodPaymentApi');
        if (endpoints.length === 1) {
          paymentEndpoint = endpoints[0].endpoint;
        }
      }

      const data = {
        id_user: user.attributes.sub,
        id_animal: this.animal.id,
        id_action: 112,
        purpose: 118,
        client: 40,
        country: 10,
        language: 'en',
        payment_type: this.paymentMethod,
        payment_period: 2,
        email: user.attributes.email,
        fname: this.firstName,
        lname: this.lastName,
        amount: parseFloat(this.amount),
        successUrl: `${window.location.origin}/#/user/payment/success`,
        errorUrl: `${window.location.origin}/#/user/payment/error`,
        paymentEndpoint,
      };

      const base64 = btoa(unescape(encodeURIComponent(JSON.stringify(data))));

      window.location.href = `${process.env.VUE_APP_PAYMENT_URL}?data=${base64}`;
      this.loading = false;
    }
  }

  private async created() {
    // TODO: check if there is an existing subscription
    const user = await Auth.currentUserInfo();

    this.gender = user.attributes.gender;
    this.firstName = user.attributes.given_name;
    this.lastName = user.attributes.family_name;
  }
}
